exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sku-image-accordion-container {\r\n    padding-top: 15px;\r\n    padding-right: 35px;\r\n    padding-bottom: 20px;\r\n    padding-left: 35px;\r\n}\r\n\r\n.image-grid {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n    margin: 0 auto 35px;\r\n    max-width: 100%;\r\n  }\r\n      \r\n  .image-bg {\r\n    background-position: center center;\r\n    background-size: cover;\r\n    -ms-flex: 0 0 auto;\r\n        flex: 0 0 auto;\r\n    margin: 5px;\r\n    width: calc(16.6667% - 10px);\r\n    cursor: pointer;\r\n  }\r\n  .image-bg-placeholder {\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n\r\n.skuimg {\r\n    display: block;\r\n    position: fixed;\r\n    top: 40px;\r\n    right: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    z-index: 14;\r\n    background: #000000ad;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inbound/asn/asn-home/asn-details/asn-sku-image-acc-content/asn-sku-image-acc-content.component.css
// module id = ../../../../../src/app/features/inbound/asn/asn-home/asn-details/asn-sku-image-acc-content/asn-sku-image-acc-content.component.css
// module chunks = main